import React from 'react';

const SvgMz = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="MZ_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="MZ_svg__b" fill="#fff">
        <use xlinkHref="#MZ_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#MZ_svg__a" />
      <path fill="#FFE547" mask="url(#MZ_svg__b)" d="M0 14.667h28V20H0z" />
      <path fill="#118C81" mask="url(#MZ_svg__b)" d="M0 0h28v5.333H0z" />
      <path fill="#FFF" mask="url(#MZ_svg__b)" d="M0 5.333h28v9.333H0z" />
      <path fill="#262626" mask="url(#MZ_svg__b)" d="M0 6.667h28v6.667H0z" />
      <path fill="#EF2147" mask="url(#MZ_svg__b)" d="M0 0l13.333 10L0 20z" />
      <path
        fill="#FDE444"
        mask="url(#MZ_svg__b)"
        d="M4.667 11.274l-1.96 1.423.748-2.303L1.496 8.97h2.422l.749-2.303.749 2.302h2.42l-1.958 1.425.748 2.303z"
      />
    </g>
  </svg>
);

export default SvgMz;
